export class SecurityAutoupdate {

  public updateVulnerable: boolean;

}
